const panelDef = (chunkName: string, entryPoint: string) => ({
  html: `${chunkName}.html`,
  vm: `${chunkName}.vm`,
  entryPoint,
  chunkName,
  url: `./${chunkName}.html`,
})

export const datasetConfig = panelDef(
  'datasetConfig',
  '@wix/wix-data-client-data-binding/dist/esm/panels/dataset-config-panel/index.js',
)
export const connectionConfig = panelDef(
  'connectionConfig',
  '@wix/wix-data-client-data-binding/dist/esm/panels/connection-config-panel/index.js',
)
export const filterPanel = panelDef(
  'filterPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/filter-panel/index.js',
)
export const sortPanel = panelDef(
  'sortPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/sort-panel/sortPanel.js',
)
export const dynamicPagesHooksPanel = panelDef(
  'dynamicPagesHooksPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/router-hooks-panel/dynamicPagesHooksPanel.js',
)
export const dynamicPageInfoPanel = panelDef(
  'dynamicPageInfoPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/page-info-panel/pageInfoPanel.js',
)
export const dynamicPageInfoPanelV2 = panelDef(
  'dynamicPageInfoPanelV2',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/page-info-panel-v2/index.js',
)
export const dynamicPageSeoPanel = panelDef(
  'dynamicPageSeoPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/page-seo-panel/pageSeoPanel.js',
)
export const dynamicPageSeoPanelV2 = panelDef(
  'dynamicPageSeoPanelV2',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/page-seo-panel-v2/index.js',
)
export const addColumnPanel = panelDef(
  'addColumnPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/add-column-panel/addColumnPanel.js',
)
export const addFieldPanel = panelDef(
  'addFieldPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/add-field-panel/addFieldPanel.js',
)
export const createDatasetPanel = panelDef(
  'createDatasetPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/create-dataset-panel/createDatasetPanel.js',
)
export const newDynamicPagePanelV4 = panelDef(
  'newDynamicPagePanelV4',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/new-dynamic-page-panel-v4/newDynamicPagePanelV4.js',
)
export const convertToDynamicPagePanelV2 = panelDef(
  'convertToDynamicPagePanelV2',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/convert-to-dynamic-page-panel-v2/convertToDynamicPagePanelV2.js',
)
export const fieldPropertiesPanel = panelDef(
  'fieldPropertiesPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/field-properties-panel/fieldPropertiesPanel.js',
)
export const presetScanningPanel = panelDef(
  'presetScanningPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/preset-scanning-panel/presetScanningPanel.js',
)
export const externalDbDriver = panelDef(
  'externalDbDriver',
  '@wix/wix-data-client-schema-management/dist/esm/panels/external-db-driver-panel/index.js',
)
export const hooksPanel = panelDef(
  'hooksPanel',
  '@wix/wix-data-client-schema-management/dist/esm/panels/hooks/index.js',
)
export const manageContentPanel = panelDef(
  'manageContentPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/manage-content-panel-V2/index.js',
)
export const newDynamicPagePanelV5 = panelDef(
  'newDynamicPagePanelV5',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/new-dynamic-page-panel-v5/newDynamicPagePanelV5.js',
)
export const newDynamicPageIntroPanel = panelDef(
  'newDynamicPageIntroPanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/new-dynamic-page-intro-panel/newDynamicPageIntroPanel.js',
)

export const dataBindingInspectorPanel = panelDef(
  'dataBindingInspectorPanel',
  '@wix/wix-data-client-studio-inspector/dist/esm/data-binding-inspector-panel/index.js',
)

export const fieldIdsPanel = panelDef(
  'fieldIdsPanel',
  '@wix/wix-data-client-data-binding/dist/esm/panels/field-ids-panel/index.js',
)

export const dynamicEditPagePanel = panelDef(
  'dynamicEditPagePanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/dynamic-edit-page-panel/dynamicEditPagePanel.js',
)

export const editDynamicPageUrlStructurePanel = panelDef(
  'editDynamicPageUrlStructurePanel',
  '@wix/wix-data-client-dynamic-pages/dist/esm/panels/edit-dynamic-page-url-structure-panel/index.js',
)
